import { SpaceBarOutlined } from '@mui/icons-material';
import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import AppContext from '../context/AppContext';

import defPic from '../assets/images/bg.jpg';

const User = ({ user, setShare }) => {
  const { theme } = useContext(AppContext);

  const { pathname } = useLocation();

  return (
    <StyledUser theme_={theme}>
      <div className="post-header">
        <span className="post-dp">
          <Link to={`/${user?.handle}`} state={{ path: `${pathname}` }}>
            <img src={user?.picture?.original?.url || defPic} alt="img" />
          </Link>
        </span>
        <span>
          <Link to={`/${user?.handle}`}>{user?.handle}</Link>
        </span>
      </div>{' '}
    </StyledUser>
  );
};
const StyledUser = styled.div`
  background: ${({ theme_ }) =>
    theme_ ? 'rgb(23, 24, 24,0.9)' : 'rgb(248, 248, 248,0.9)'};
  border-radius: 0.5rem;
  display: flex;
  flex-flow: column wrap;
  font-size: 1.2rem;
  overflow: hidden;
  -moz-box-shadow: 0 0 3px #ccc;
  -webkit-box-shadow: 0 0 3px #ccc;
  box-shadow: 0 0 3px #ccc;
  @media screen and (max-width: 900px) {
    -moz-box-shadow: 0 0 3px #ccc;
    -webkit-box-shadow: 0 0 3px #ccc;
    box-shadow: 0 0 3px #ccc;
    clip-path: inset(0px 0px -15px 0px);
    border-radius: 0rem;
  }
  .post-header {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
    padding: 1rem 1rem;

    .post-dp {
      border-radius: 50%;
      background: grey;
      width: 3rem;
      height: 3rem;
      overflow: hidden;

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
`;
export default User;
